import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'src/i18n/messages.js';
Vue.use(VueI18n);
var i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: messages
});
export default (function (_ref) {
  var app = _ref.app;
  // Set i18n instance on app
  app.i18n = i18n;
});
export { i18n };